"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isDefined = void 0;
/**
 * Tests to see if a variable is defined
 *
 * @name isDefined
 * @param {variable} target Variable to validate
 * @returns {boolean} Indicator if variable is defined (not null or undefined)
 */
const isDefined = target => {
  return target !== null && target !== undefined;
};
exports.isDefined = isDefined;